// src/pages/projects/work-at-thinkmarkets.jsx
import "./projects.css";
import SectionMediaRight from "../../components/section-templates/SectionMediaRight";
import BentoBoxSection from "../../components/section-templates/BentoBoxSection";
import CardTextSection from "../../components/section-templates/CardTextSection";
import VideoGridSection from "../../components/section-templates/VideoGridSection";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";

export default function WorkAtThinkMarkets() {
  // 4 GIFs/images for the bento grid
  const gallery = [
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/promo-charts.webp",
      alt: "First",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/hand-animation.webp",
      alt: "Second",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/trading-view.webp",
      alt: "Third",
    },
    {
      src: "../assets/Images/Portfolio/work-at-thinkmarkets/btc-halving.webp",
      alt: "Fourth (wide)",
    },
  ];

  // VIDEOS

  const videos = [
    {
      title: "15 year anniversary of ThinkMarkets",
      src: "https://www.youtube.com/watch?v=qrxsG_7DPPQ",
      description: "Anniversary celebration of TM. Awareness campaign.",
      tags: ["After Effects", "Blender", "Premiere", "Audition"],
    },
    {
      title: "Appstore / Playstore Animation",
      src: "https://www.youtube.com/watch?v=aA--1k1lrcM",
      description: "AppStore and Playstore trailer.",
      tags: ["Blender", "After Effects"],
    },
    {
      title: "ThinkTrader Promo",
      src: "https://www.youtube.com/watch?v=-9xs_PJr3_E",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "Dynamic Leverage Explainer",
      src: "https://www.youtube.com/watch?v=2z35kyfPBus",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    {
      title: "BTC Halving Explainer",
      src: "https://www.youtube.com/watch?v=VIF5bGccNgk",
      description: "Explaining the Bitcoin halving event.",
      tags: ["Premiere Pro", "After Effects", "Photoshop", "Illustrator"],
    },
    {
      title: "TM X TV Promo",
      src: "https://www.youtube.com/watch?v=TxjO_5Ij93w",
      description: "Awareness campaign.",
      tags: ["After Effects"],
    },
    // …add as many as you like…
  ];

  // REMOVE VALUE BELOW
  // This is the metric data for the CardTextSection
  const myMetric = {
    title: "My Total Views vs. ThinkMarkets Average",
    value: 4500,
    changePercent: 2122.22,
    changeDescription: "estimated overall",
    data: [1, 25, 50, 100],
  };

  // Data for the full-width biaxial chart inside CardTextSection
  const chartData = [
    { name: "Jan", me: 1932, thinkmarkets: 798 },
    { name: "Feb", me: 3535, thinkmarkets: 1405 },
    { name: "Mar", me: 6565, thinkmarkets: 2488 },
    { name: "Apr", me: 8809, thinkmarkets: 3310 },
    { name: "May", me: 11048, thinkmarkets: 4082 },
    { name: "Jun", me: 26473, thinkmarkets: 5291 },
    { name: "Jul", me: 34408, thinkmarkets: 6942 },
  ];
  return (
    <>
      <MotionContainer className="container thinkmarkets-page">
        {/* Spacer */}
        <MotionItem className="thinkmarkets-spacer" />

        {/* Title */}
        <MotionItem delayChildren={0.02}>
          <h2 className="main-title">My contribution at ThinkMarkets</h2>
        </MotionItem>

        {/* Overview & Approach */}
        <div className="info-columns">
          <MotionItem delayChildren={0.02} className="info-block">
            <h2>Overview</h2>
            <p>
              ThinkMarkets is a fintech company offering multi-asset trading
              platforms. I worked on motion design to enhance brand storytelling
              and increase user engagement.
            </p>
          </MotionItem>
          <MotionItem className="info-block">
            <h2>Approach</h2>
            <p>
              I created a scalable animation library and design system using{" "}
              <strong>AI tools</strong>, <strong>2D</strong>, and{" "}
              <strong>3D</strong>. This helped visualize complex financial
              concepts, streamlined production, and improved clarity and
              engagement across platforms.
            </p>
          </MotionItem>
        </div>

        {/* Full-width media */}
        <MotionItem className="IMG-fullmedia">
          <img
            className="thinkmarkets-fullmedia-image"
            src="/assets/Images/Portfolio/work-at-thinkmarkets/thinkmarkets-header.webp"
            alt="ThinkMarkets project overview"
          />
        </MotionItem>
      </MotionContainer>

      {/* Only this section now */}

      <SectionMediaRight
        imageSrc="/assets/Images/Portfolio/work-at-thinkmarkets/animation-system.webp"
        title="40% Faster Delivery with Animation System"
        text="I built a reusable animation library and a set of how-to templates that standardize our video creation process. This toolkit cuts 3-4 hours of work per project and drives a measurable boost in overall production efficiency."
      />
      <CardTextSection
        metric={myMetric}
        heading="My Motion Design & Strategy Impact"
        description={
          <>
            Over the past 12 months, the slice of total organic reach driven by
            our videos has climbed steadily, thanks to my motion-design
            expertise, video production skills, and strategic content planning.
            In that time, we also saw our click-through rate lift by{" "}
            <strong>2.9%</strong>, a testament to more engaging thumbnails,
            tighter calls-to-action, and cohesive storytelling.
          </>
        }
        chartData={chartData}
        chartFooter="Calculated on July 9, 2025"
      />

      {/* BENTO BOX GALLERY */}
      <BentoBoxSection items={gallery} />

      <VideoGridSection
        title="Some of my videos"
        description="A showcase of my work at ThinkMarkets, including explainer videos, promotional content, and more."
        videos={videos}
      />
    </>
  );
}
